function SingleEstate() {
	if(document.body.classList.contains('single-estate')) {

		let swiperThumb = new Swiper('.swiper-estate-thumbs', {
			// loop: true,
			freeMode: true,
			spaceBetween: 4,
			slidesPerView: 8,
			watchSlidesProgress: true,
			allowTouchMove: false
		});

		let swiper = new Swiper('.swiper-estate', {
			loop: true,
			navigation: {
				nextEl: ".swiper-estate .swiper-button-next",
				prevEl: ".swiper-estate .swiper-button-prev",
			},
			thumbs:  {
				swiper: swiperThumb
			}
		});


	}


}